import { Component, Inject, Injector, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { isEmpty, toUpper } from 'lodash';
import { SuspendTransactionPromptConfirmationComponent } from 'src/app/pages/suspensions/components/suspend-transaction-prompt-confirmation/suspend-transaction-prompt-confirmation.component';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { CACHE_URL_KEY } from 'src/app/shared/constants/constant-list';
import {
  ReceiverInformation,
  SenderInformation,
  UserTransactionsObject,
} from 'src/app/shared/interfaces/RemiitancePlatforms';
import { LocalStorageService } from 'src/app/shared/services';
import {
  IS_RIA_REMITTANCE,
  IS_TRANSACTION_B2P,
  IS_TRANSACTION_CASH_IN,
  IS_TRANSACTION_CASH_OUT,
  IS_TRANSACTION_DONATION,
  IS_TRANSACTION_P2B,
  IS_TRANSACTION_P2P,
  IS_TRANSACTION_PAYMENT,
  IS_TRANSACTION_REMITTANCE,
  IS_TRANSACTION_TOP_UP,
  IS_TRANSFER,
} from 'src/app/shared/utils/transaction_utils';

@Component({
  selector: 'app-user-profile-transaction-details',
  templateUrl: './user-profile-transaction-details.component.html',
  styleUrls: ['./user-profile-transaction-details.component.scss'],
})
export class UserProfileTransactionDetailsComponent
  extends ListingBaseComponent
  implements OnInit
{
  details: any;
  locationLabel?: string;
  senderCountry?: string;
  transferReason?: string;

  remittancePlatform?: string;
  relationship?: string;
  labelDate?: string;
  userID?: number;
  profileID?: number;
  labelName?: string;

  activeTab: string | null = null;

  STATUS_HISTORY?: any[] = [];

  CARD_DETAILS?: {
    card_holder_name?: string;
    card_number?: string;
    funding_method?: string;
    device_ip_address?: string;
  };

  constructor(
    injector: Injector,
    private localService: LocalStorageService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      details: any;
      userID: number;
    },
    public dialogRef: MatDialogRef<UserProfileTransactionDetailsComponent>
  ) {
    super(injector);

    this.details = data.details;
    this.userID = data.userID;
  }

  ngOnInit(): void {
    this.locationLabel =
      this.details.type === 'CASH_OUT' ? 'Cash out' : 'Sender';

    if (this.details?.transaction_object?.type === 'top-up') {
      this.CARD_DETAILS = this.details?.transaction_object?.sender;
    }

    this.getStatusHistory();
  }

  onSuspendTransaction(transaction: any, isSuspend: boolean) {
    this.dialog.open(SuspendTransactionPromptConfirmationComponent, {
      data: {
        isSuspend: !isSuspend,
        transaction: transaction,
        suspend: 'transaction',
      },
      width: '500px',
    });
  }

  renderTransactionName(
    type: string,
    transaction_type: string,
    sender: SenderInformation,
    receiver: ReceiverInformation,
    transaction_object: UserTransactionsObject
  ) {
    const TRANSACTION_TYPE = toUpper(transaction_type);
    const TYPE_ = toUpper(type);
    let transactionName = '';

    if (IS_TRANSFER(TYPE_)) {
      if (IS_TRANSACTION_P2P(TRANSACTION_TYPE)) {
        if (this.userID === sender?.app_user_id) {
          transactionName = !isEmpty(receiver?.app_user)
            ? receiver?.app_user?.first_name_en +
              ' ' +
              receiver?.app_user?.last_name_en
            : receiver?.first_name + ' ' + receiver?.last_name;

          this.profileID = receiver?.app_user_id;
        } else if (this.userID === receiver?.app_user_id) {
          if (!isEmpty(sender?.app_user)) {
            transactionName =
              sender?.app_user?.first_name_en +
              ' ' +
              sender?.app_user?.last_name_en;
          } else {
            transactionName = sender?.name
              ? sender?.name
              : sender.first_name + ' ' + sender.last_name;
          }
          this.labelName = 'Received from';
          this.profileID =
            sender?.app_user_id === undefined ? 0 : sender?.app_user_id;
        }
      } else if (
        IS_TRANSACTION_B2P(TRANSACTION_TYPE) ||
        IS_TRANSACTION_P2B(TRANSACTION_TYPE) ||
        IS_TRANSACTION_TOP_UP(TRANSACTION_TYPE)
      ) {
        transactionName = sender?.name;
        this.profileID = sender?.app_user === null ? 0 : sender?.app_user_id;
      } else if (IS_TRANSACTION_DONATION(TRANSACTION_TYPE)) {
        transactionName = receiver?.first_name + ' ' + receiver?.last_name;
        this.profileID = receiver?.app_user_id;
      }
    } else if (IS_TRANSACTION_CASH_OUT(TYPE_)) {
      transactionName = transaction_object?.final_cash_out_branch_name;
      this.profileID = sender?.app_user_id;
    } else if (IS_TRANSACTION_REMITTANCE(TYPE_)) {
      transactionName = transaction_object?.sender_name;
      this.profileID = 0;
    } else if (IS_TRANSACTION_CASH_IN(TYPE_)) {
      transactionName = transaction_object?.branch?.name;
      this.profileID = 0;
    } else if (IS_TRANSACTION_PAYMENT(TYPE_)) {
      transactionName = transaction_object?.merchant_name;
      this.profileID = sender?.app_user_id;
    }

    return transactionName;
  }

  renderTransactionNameLabel(
    type: string,
    transaction_type: string,
    sender: SenderInformation
  ) {
    const TRANSACTION_TYPE = toUpper(transaction_type);
    const TYPE_ = toUpper(type);
    let transactionNameLabel = '';

    if (IS_TRANSFER(TYPE_)) {
      if (IS_TRANSACTION_P2P(TRANSACTION_TYPE)) {
        transactionNameLabel =
          this.userID === sender?.app_user_id ? 'Sent to' : 'Received from';
      } else if (
        IS_TRANSACTION_B2P(TRANSACTION_TYPE) ||
        IS_TRANSACTION_P2B(TRANSACTION_TYPE) ||
        IS_TRANSACTION_TOP_UP(TRANSACTION_TYPE) ||
        IS_TRANSACTION_DONATION(TRANSACTION_TYPE)
      ) {
        transactionNameLabel = 'Received from';
      }
    } else if (
      IS_TRANSACTION_CASH_OUT(TYPE_) ||
      IS_TRANSACTION_REMITTANCE(TYPE_) ||
      IS_TRANSACTION_PAYMENT(TYPE_)
    ) {
      transactionNameLabel = 'Received from';
    } else if (IS_TRANSACTION_CASH_IN(TYPE_)) {
      transactionNameLabel = 'Sent to';
    }

    return transactionNameLabel;
  }

  onViewProfile(event: any): void {
    if (event) {
      this.localService.setDataInLocalStorage({
        key: CACHE_URL_KEY,
        value: this.params.toString(),
      });
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/users/app-users/${event}`])
      );
      window.open(url, '_blank');
    }
  }

  renderRemittancePlatform(
    type: string,
    transaction_object: UserTransactionsObject
  ) {
    const TYPE_ = toUpper(type);

    if (IS_TRANSFER(TYPE_)) {
      this.remittancePlatform =
        transaction_object?.type === 'top-up' ? 'Top-up' : '';
    } else {
      this.remittancePlatform = transaction_object?.remittance_platform_name;
    }

    return this.remittancePlatform;
  }

  renderRelationship(type: string, transaction_object: UserTransactionsObject) {
    const TYPE_ = toUpper(type);

    this.relationship = IS_TRANSFER(TYPE_)
      ? transaction_object?.sender_receiver_relationship
      : transaction_object?.sender_relationship_to_receiver;
    return this.relationship;
  }

  renderLabelDate(type: string, transaction_object: UserTransactionsObject) {
    const TYPE_ = toUpper(type);
    this.labelDate = IS_TRANSACTION_CASH_OUT(TYPE_)
      ? 'Cashed out On'
      : ' Received On';

    return this.labelDate;
  }

  renderSenderCountry(type: string) {
    const TYPE_ = toUpper(type);
    if (IS_TRANSACTION_CASH_OUT(TYPE_) || IS_TRANSFER(TYPE_)) {
      this.senderCountry =
        this.details?.transaction_object?.final_cash_out_branch_name;
    } else {
      this.senderCountry = this.details?.transaction_object?.sender_country;
    }

    return this.senderCountry;
  }

  renderTransferReason(type: string) {
    const TYPE_ = toUpper(type);

    this.transferReason = IS_TRANSFER(TYPE_)
      ? this.details?.transaction_object?.purpose
      : this.details?.transaction_object?.transfer_purpose;

    return this.transferReason;
  }

  renderAmount(transaction_object: UserTransactionsObject) {
    const extra_data = transaction_object?.extra_data;
    const amounts = extra_data?.amounts;

    const amount = IS_RIA_REMITTANCE(this.details?.remittance)
      ? Number(amounts?.final?.value).toFixed(2)
      : Number(this.details?.amount).toFixed(2);

    return amount;
  }

  renderTransactionFee(transaction_object: UserTransactionsObject) {
    const extra_data = transaction_object?.extra_data;
    const amounts = extra_data?.amounts;

    const fees = IS_RIA_REMITTANCE(this.details?.remittance)
      ? Number(amounts?.fees?.value).toFixed(2)
      : 0;

    return fees;
  }

  getStatusHistory() {
    this.STATUS_HISTORY = this.details?.transaction_object?.status_history;
  }

  close() {
    this.dialogRef.close();
  }

  tabChange(event: { nextId: string }) {
    this.activeTab = event?.nextId;
  }
}
